import React from "react";
import get from "lodash/get";
import moment from "moment";
import { connect } from "react-redux";
import {
  Layout,
  Table,
  Switch,
  Button,
  Modal,
  message,
  Tooltip,
  Icon,
  Input, Badge, Alert, Checkbox,
} from "antd";

import EmailTemplatesFormWrapper from "./EmailTemplatesForm/EmailTemplatesFormWrapper";
import classes from "./EmailTemplates.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getEmailTemplatesRequest,
  toggleEmailTemplateActivationRequest,
  toggleEmailTemplateApproveRequest,
  getSettingsRolesRequest,
  getSitesRequest,
  sendNewsletterRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getEmailTemplateUpdatePermission,
  getEmailTemplateDeletePermission,
  getEmailTemplateActivatePermission,
  getEmailTemplateApprovePermission, getAllowLoadingEmailTemplatesFromDB
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";
import {getFormErrorMessage} from "../../utils/errorHandler";

const { Content } = Layout;
const { Search } = Input;

class EmailTemplates extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newsletters: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "asc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      emailTemplate: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      approvedSelected: null,
      sendingId: null,
      roles: [],
      is_modified: false,
      is_overridden: false,
      is_approved: false,
    };
  }

  async componentDidMount() {
    await this.onNameSearch();

    try {
      const { data } = await getSettingsRolesRequest();
      const { data: sites } = await getSitesRequest();
      this.setState({ roles: data, sites });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getNewsletter
    );
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getNewsletter);
  };

  getNewsletter = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getEmailTemplatesRequest({
        search: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        is_modified: this.state.is_modified,
        is_overridden: this.state.is_overridden,
        is_approved: this.state.is_approved,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });

      this.setState({
        newsletters: Array.isArray(data.data) ? data.data : [],
        total: data.total_pages * per_page,
        currentPage: page,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        newsletters: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getNewsletter(pagination.current, pagination.pageSize)
    );
  };

  onEmailTemplateEdit = (newsletter) => () => {
    this.setState({ emailTemplate: newsletter });
  };

  onEmailTemplateEditHide = () => {
    this.setState({ emailTemplate: null });
  };

  onEmailTemplateEditSubmit = () => {
    this.setState({ emailTemplate: null }, this.getNewsletter);
  };

  addNewsletter = () => {
    this.setState({ emailTemplate: {} });
  };

  onSwitchNewsletterActivation = (id, state) => async () => {
    try {
      await toggleEmailTemplateActivationRequest(id);

      message.success(this.props.i18n.t("Saved"));

      this.getNewsletter();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
    }
  };

  onSwitchNewsletterApprove = (id, state) => async () => {
    try {
      await toggleEmailTemplateApproveRequest(id);

      message.success(this.props.i18n.t("Saved"));

      this.getNewsletter();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
    }
  };

  onSend = async (id) => {
    this.setState({
      sendingId: id,
    });

    try {
      await sendNewsletterRequest(id);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(getFormErrorMessage(e));
    }

    this.setState({
      sendingId: null,
    });

    this.getNewsletter();
  };

  render() {
    const {
      isLoading,
      sites,
      newsletters,
      currentPage,
      total,
      pageSize,
      emailTemplate,
      roles,
      nameSearch,
    } = this.state;

    const columns = [
      {
        dataIndex: "alias",
        key: "alias",
        title: this.props.i18n.t("Alias"),
      },
      {
        dataIndex: "body_modified",
        key: "body_modified",
        title: this.props.i18n.t("NamespaceEmailTemplates:Modified"),
        render: (val, data) => (
          <Badge
                    count={
                      get(data, "is_modified")
                        ? this.props.i18n.t("Modified")
                        : ""
                    }
                    style={{
                      backgroundColor: "#fc6262"
                    }}
                  />
        )
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, newsletter) => (
          <div className={classes.actions}>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("NamespaceEmailTemplates:Edit template")}
            >
              <Icon
                type="edit"
                theme="filled"
                className={classes.iconEdit}
                onClick={this.onEmailTemplateEdit(newsletter)}
              />
            </Tooltip>
            &nbsp; &nbsp;
            <div style={{ width: "90px", display: "flex" }}>
              {this.props.getEmailTemplateActivatePermission && (
                <div>
                  <b className={classes.switchLabel}>
                    {this.props.i18n.t("NamespaceEmailTemplates:Override")}
                  </b>
                  <br />
                  <Tooltip
                    placement="topLeft"
                    title={this.props.i18n.t("NamespaceEmailTemplates:Disable/ Enable override")}
                  >
                    <Switch
                      className={classes.reactivateBtn}
                      checked={newsletter.state === "active"}
                      onChange={this.onSwitchNewsletterActivation(
                        val,
                        newsletter.state
                      )}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceEmailTemplates:Email Templates")}
            </h3>

            {!this.props.getAllowLoadingEmailTemplatesFromDB && (
              <div>
                <Alert message={this.props.i18n.t("NamespaceEmailTemplates:WARNING! Loading email templates from the database is turned OFF in the project settings. The changes made here will have no effect.")} type="error" />
                &nbsp; &nbsp;
              </div>
            )}

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Search
                  placeholder={this.props.i18n.t("By name")}
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            <h4 className="headline-default">{this.props.i18n.t("Filter")}</h4>
            <div className={classes.wrapperFilters}>
              <div className={classes.wrapperFiltersItem}>
                <Checkbox
                  onChange={() => {
                    this.setState({
                      is_modified: !this.state.is_modified,
                      currentPage: 1,
                    }, this.getNewsletter)
                  }}
                  checked={this.state.is_modified}
                >
                  {this.props.i18n.t("NamespaceEmailTemplates:Is modified")}
                </Checkbox>
              </div>
              <div className={classes.wrapperFiltersItem}>
                <Checkbox
                  onChange={() => {
                    this.setState({
                      is_overridden: !this.state.is_overridden,
                      currentPage: 1,
                    }, this.getNewsletter)
                  }}
                  checked={this.state.is_overridden}
                >
                  {this.props.i18n.t("NamespaceEmailTemplates:Is overriden")}
                </Checkbox>
              </div>
            </div>

            {/*<div>
              <Button type="primary" onClick={this.addNewsletter}>
                {this.props.i18n.t("NamespaceNewsletter:Add email template")}
              </Button>
              <br />
              <br />
            </div>*/}

            <Table
              columns={columns}
              dataSource={newsletters}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: "both",
              }}
            />

            <Modal
              visible={!!emailTemplate}
              onCancel={this.onEmailTemplateEditHide}
              footer={null}
              width="90%"
            >
              {emailTemplate && (
                <EmailTemplatesFormWrapper
                  roles={roles}
                  sites={sites}
                  id={emailTemplate.id}
                  isNew={emailTemplate && !emailTemplate.id}
                  onSubmit={this.onEmailTemplateEditSubmit}
                  onCancel={this.onEmailTemplateEditHide}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  emailTemplateUpdatePermission: getEmailTemplateUpdatePermission(state),
  emailTemplateDeletePermission: getEmailTemplateDeletePermission(state),
  getEmailTemplateActivatePermission: getEmailTemplateActivatePermission(state),
  getEmailTemplateApprovePermission: getEmailTemplateApprovePermission(state),
  getAllowLoadingEmailTemplatesFromDB: getAllowLoadingEmailTemplatesFromDB(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(EmailTemplates))
);



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/EmailTemplates.js